// extracted by mini-css-extract-plugin
module.exports = {"ResourcesCol":"Platform_ResourcesCol__XalLj","PlatformOverviewImage":"Platform_PlatformOverviewImage__8_Enz"};